export default "__VITE_ASSET__d7bb4319__"